import { createContext, useContext } from 'react';

const noop = () => {};

export const DEFAULT_HELP_CONTEXT = Object.freeze({
    canUseOrientation: false,
    orientationStatus: 'idle',
    currentStep: null,
    currentStepIndex: 0,
    totalSteps: 0,
    target: null,
    targetState: 'idle',
    waiting: null,
    invitationKind: null,
    startOrientation: noop,
    resumeOrientation: noop,
    restartOrientation: noop,
    pauseOrientation: noop,
    dismissOrientation: noop,
    postponeOrientation: noop,
    nextOrientationStep: noop,
    previousOrientationStep: noop,
    beginOrientationInteraction: noop,
    continueWaitingOrientation: noop,
    pauseWaitingOrientation: noop,
});

export const HelpContext = createContext(DEFAULT_HELP_CONTEXT);

export const useHelp = () => useContext(HelpContext);
